import React from 'react';

const BookingEmbed = ({ height = "1000px" }) => {
  return (
    <div className="w-full">
      <iframe 
        width="100%" 
        height={height}
        src="https://ehr.charmtracker.com/publicCal.sas?method=getCal&digest=870a4f4e71c4aa8e9e459a5d00854fd72b4586bd7c48d3286cfb49e5d46bf0822fc9c2738e1cf54d288b4d6bb9deaf51d2bec0af04f23226" 
        style={{ overflow: 'hidden' }}
        frameBorder="0"
        title="Book Appointment"
      />
    </div>
  );
};

export default BookingEmbed;
